import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

/* eslint-disable react/no-danger */
import { getDriverFixedApr, getDriverFixedAprWithAnnotation, getDriverMinCreditScore as getQuickFactMinCreditScore, getDriverVariableApr, getDriverVariableAprWithAnnotation } from '@nerdwallet/marketplace/drivers/education-loans';
/**
 * Convert UNSAFE_valueTooltip (disclaimer) to a react component.
 */

var getQuickFactFixedAPR = function getQuickFactFixedAPR(offer) {
  var _getDriverFixedApr = getDriverFixedApr(offer),
      valueTooltip = _getDriverFixedApr.UNSAFE_valueTooltip,
      driver = _objectWithoutProperties(_getDriverFixedApr, ["UNSAFE_valueTooltip"]);

  return _objectSpread(_objectSpread({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};
/**
 * Convert UNSAFE_valueTooltip (fixed_apr_annotation) to a react component.
 */


var getQuickFactFixedAPRWithAnnotation = function getQuickFactFixedAPRWithAnnotation(offer) {
  var _getDriverFixedAprWit = getDriverFixedAprWithAnnotation(offer),
      valueTooltip = _getDriverFixedAprWit.UNSAFE_valueTooltip,
      driver = _objectWithoutProperties(_getDriverFixedAprWit, ["UNSAFE_valueTooltip"]);

  return _objectSpread(_objectSpread({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};
/**
 * Convert UNSAFE_valueTooltip (disclaimer) to a react component.
 */


var getQuickFactVariableAPR = function getQuickFactVariableAPR(offer) {
  var _getDriverVariableApr = getDriverVariableApr(offer),
      valueTooltip = _getDriverVariableApr.UNSAFE_valueTooltip,
      driver = _objectWithoutProperties(_getDriverVariableApr, ["UNSAFE_valueTooltip"]);

  return _objectSpread(_objectSpread({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};
/**
 * Convert UNSAFE_valueTooltip (variable_apr_annotation) to a react component.
 */


var getQuickFactVariableAPRWithAnnotation = function getQuickFactVariableAPRWithAnnotation(offer) {
  var _getDriverVariableApr2 = getDriverVariableAprWithAnnotation(offer),
      valueTooltip = _getDriverVariableApr2.UNSAFE_valueTooltip,
      driver = _objectWithoutProperties(_getDriverVariableApr2, ["UNSAFE_valueTooltip"]);

  return _objectSpread(_objectSpread({}, driver), {}, {
    valueTooltip: valueTooltip ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: valueTooltip
      }
    }) : null
  });
};
/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/drivers/education-loans` directly.
 */


export { getQuickFactFixedAPR, getQuickFactFixedAPRWithAnnotation, getQuickFactMinCreditScore, getQuickFactVariableAPR, getQuickFactVariableAPRWithAnnotation };